import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import { saveSettingsKey } from 'app/common/actions/settings/save';
import selectAssignedList from './selectAssignedList';


// type Props = {
//   id: string, // id выбранного студента
// };

const enhance = compose(
  withTranslation('subs'),

  connect(
    (state, props) => ({
      subsData: selectAssignedList(state, props),
    }),
    dispatch => ({
      handleSwitchChosen: (e) => {
        const { value, checked } = e.target;
        dispatch(saveSettingsKey('fav', { [value]: checked }));
      },
    }),
  ),
);

export default enhance;
